import React from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import "./manage-swiper.css";
import "./manage.css";
import ali from "../images/avatar-ali.png";
import anisha from "../images/avatar-anisha.png";
import richard from "../images/avatar-richard.png";
import shanai from "../images/avatar-shanai.png";

const MySwiper = () => {
  let swiper = null;

  function updateSwiper(s) {
    swiper = s;
  }

  const params = {
    slidesPerView: "auto",
    spaceBetween: 40,
    centeredSlides: true,
    loop: true,
    on: {
      slideChange: () => {
        if (swiper) {
          console.log(swiper.realIndex);
        }
      }
    }
  };

  return (
    <div className="card-list">
      <Swiper {...params} getSwiper={updateSwiper}>
        <div className="card">
          <img src={anisha} alt="avatar" />
          <p className="card-header">Anisha Li</p>
          <p className="card-body">
            “Manage has supercharged our team’s workflow. The ability to
            maintain visibility on larger milestones at all times keeps everyone
            motivated.”
          </p>
        </div>
        <div className="card">
          <img src={ali} alt="avatar" />
          <p className="card-header">Ali Bravo</p>
          <p className="card-body">
            {" "}
            “We have been able to cancel so many other subscriptions since using
            Manage. There is no more cross-channel confusion and everyone is
            much more focused.”
          </p>
        </div>
        <div className="card">
          <img src={richard} alt="avatar" />
          <p className="card-header">Richard Watts</p>
          <p className="card-body">
            “Manage allows us to provide structure and process. It keeps us
            organized and focused. I can’t stop recommending them to everyone I
            talk to!”
          </p>
        </div>
        <div className="card">
          <img src={shanai} alt="avatar" />
          <p className="card-header">Shanai Gough</p>
          <p className="card-body">
            “Their software allows us to track, manage and collaborate on our
            projects from anywhere. It keeps the whole team in-sync without
            being intrusive.”
          </p>
        </div>
      </Swiper>
    </div>
  );
};

export default MySwiper;
